<template>
    <div class="intro-page">
        <div class="background-image" :style="{'background': 'url(' + (form.profileImage && form.profileImage.filePath ? form.profileImage.filePath + form.profileImage.fileName : defaultImage) + ')'}">
            <h1 v-if="!user.companyName && !user.customerLogo" class="logo">
                <!-- Kollecto -->
                <icon class="large-svg" name="kollecto"></icon>
                <span>Kollecto</span>
            </h1>
            <div class="content">
                <div class="flexbox-center full-height">
                    <div class="inner-content">
                        <!-- Company -->
                        <div v-if="user.companyName || user.customerLogo" class="company-info">
                            <!-- <div>
                                <img v-if="user.customerLogo && user.customerLogo" :src="user.customerLogo" class="company-logo">
                            </div> -->
                            <div class="text-container">
                                <!-- <span v-if="user.companyName"><b>{{user.companyName}}</b></span> -->
                            </div>
                        </div>
                        <div v-if="form.formId">
                            <h2 v-if="form.name">{{form.name}}</h2>
                            <p v-if="form.introText">{{form.introText}}</p>
                            <div class="button-container">
                                <a class="button button-primary" @click="handleNextStep()">Start</a>
                            </div>
                        </div>
                        <div v-else>
                            <h3 style="margin-top: 50px;">Ingen formular angivet</h3>        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "intropage",
  data() {
    return {
      defaultImage: require("./../../../assets/images/image4-compressed.png")
    };
  },
  computed: {
    ...mapGetters({
      user: "getUserData",
      form: "getActiveForm",
      repeaterRegistrations: "getRepeaterItems"
    })
  },
  methods: {
    ...mapActions({
      handleNextStep: "handleNextStep",
      clearRepeaterRegistrations: "clearRepeaterRegistrations"
    })
  },
  created() {
    if (this.repeaterRegistrations.length > 0) {
      this.clearRepeaterRegistrations();
    }
  }
};
</script>
